import { Form } from 'react-bootstrap';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from 'redux/store';
import { fetchSchedulingWindows } from '../../../../../../../redux/slices/scheduling_windowsSlice';

type Props = {
  selectedValue?: string | null;
  defaultValue?: string | null;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  queryParams?: Record<string, any>;
};

const ScheduleWindowsSelect = ({ selectedValue, defaultValue = '', onChange, placeholder = '-- (null)', queryParams }: Props) => {
  const dispatch = useAppDispatch();
  const items = useSelector((state: RootState) => state.schedulingWindow.items);

  useEffect(() => {
    dispatch(fetchSchedulingWindows(queryParams || {}));
  }, [dispatch, queryParams]);

  const value = (selectedValue ?? defaultValue ?? '') as string;

  const options = useMemo(() => {
    return (items ?? [])
      .filter((win) => (win.name ?? '').trim().length > 0)
      .sort((a, b) =>
        (a.name ?? '').localeCompare(b.name ?? '', undefined, {
          sensitivity: 'base',
        })
      );
  }, [items]);

  return (
    <Form.Group className="mb-2" controlId="formSchedulingWindows">
      <Form.Label>Precondition Schedule Windows</Form.Label>
      <Form.Select aria-label="precondition scheduling-windows-select" name="scheduling_window" value={value} onChange={onChange}>
        <option value="">{placeholder}</option>
        {options.map((win) => {
          const zone = win.zone_name ?? '—';
          const key = `${win.scheduling_window_id}`;
          const optionValue = `${zone}|${win.name}`;
          return (
            <option key={key} value={optionValue}>
              {win.name} ({zone})
            </option>
          );
        })}
      </Form.Select>
    </Form.Group>
  );
};

export default ScheduleWindowsSelect;
